/**
 * Enum of the IDs of the profile properties that we access in a BlueConic profile.
 */
export enum BlueConicProfileProperties {
  /**
   * Unique identifier for CBC authenticated users.
   */
  cbcPlusId = "cbc_plus_id",
  /**
   * Unique identifier for CBC anonymous users.
   */
  cbcVisitorId = "cbc_visitor_id",

  /**
   * FSA group ID used to link with Environics data.
   * Based (in order of priority) on the postal code declared by the user, the postal code most frequently detected,
   * or the postal code most recently detected.
   */
  fsaGroupId = "fsa_groupid_",
  /**
   * Postal code declared by the user when they registered or updated their account.
   */
  postalCodeDeclared = "postal_code",

  /**
   * FSA chosen when a user confirm their region in the Radio-Canada information website
   */
  fsaCodeRegion = "fsa_region",

  /**
   * Postal code most recently detected with the user's IP address.
   */
  postalCodeMostRecent = "postal_code_most_recent",

  /**
   * Postal code most frequently detected with the user's IP address.
   * Computed from the Start Web Session timeline events in BlueConic.
   */
  postalCodeMostFrequent = "postal_code_most_frequent",

  /**
   * Postal code chosen when a user confirm their region in the Radio-Canada information website
   */
  postalCodeRegion = "postal_code_region",

  /**
   * Postal code used to link with Environics data.
   * Based (in order of priority) on the postal code declared by the user, the postal code most frequently detected,
   * or the postal code most recently detected.
   */
  postalCodeGroupId = "postal_code_group_id",

  /**
   * Unique identifier for Radio-Canada or CBC GEM authenticated users.
   */
  rcId = "rc_id",

  /**
   * Unique identifier for Radio-Canada anonymous users.
   */
  rcVisitorId = "rc_visitor_id",

  /**
   * The last time a RC_Loaded event was added to the profile's timeline events
   */
  rcLastLoadedEventDate = "rc_last_loaded_event_date",

  /**
   * The last time a RC_Read event was added to the profile's timeline events
   */
  rcLastReadEventDate = "rc_last_read_event_date",

  /**
   * The last time a RC_Start_Web_Session event was added to the profile's timeline events
   */
  rcLastStartWebSessionEventDate = "rc_last_start_web_session_event_date",

  /**
   * The last time a RC_Streamed_Audio event was added to the profile's timeline events
   */
  rcLastStartStreamedAudioEventDate = "rc_last_start_streamed_audio_event_date",

  /**
   * The last time a RC_Streamed_Video event was added to the profile's timeline events
   */
  rcLastStartStreamedVideoEventDate = "rc_last_start_streamed_video_event_date",

  /**
   * Property containing the consent of the user for the use of this data for targeted advertising
   */
  targetedAds = "cmp_targeted_ads",

  /**
   * Property containing the consent of the user for the use of this data for targeted content
   */
  targetedContent = "cmp_targeted_content",

  /**
   * Number of page views registered on the current profile
   */
  totalPageViews = "clickcount",
}
